export enum Stack {
  'local' = 0,
  'dev' = 1,
  'pie' = 2,
  'stg' = 3,
  'pro' = 4,
  'custom' = 5,
}

export interface KeyEvent {
  activity: string;
  screenPath: string;
  screenName: string;
  action: string;
  controlName?: string;
  actionAuxParams?: string | string[];
  screenMode?: string | string[];
  trackingAlias?: string; //only used to track the event in the monitoring dashboards
}

export type KeyEventsByPath = Record<string, KeyEvent[]>;

const pdpConfigKeyEvents: KeyEvent[] = [
  {
    activity: 'HpOneEnrollment-v02',
    screenPath: '/MagentoStorefront/',
    screenName: 'PrinterConfigurationPage',
    action: 'ScreenDisplayed',
    actionAuxParams: 'selected_sku=<sku>&pdp_flow=<flow>', // corner case -> there are multiple events where we have the same pdp config SD skeleton, this actionAuxParams differs them from the key event that we want to track
  },
];
const cartKeyEvents: KeyEvent[] = [
  {
    activity: 'HpOneEnrollment-v02',
    action: 'ScreenDisplayed',
    screenName: 'SummaryPage',
    screenPath: '/MagentoStorefront/',
  },
];

const cartKeyEventsOnRouteChange: KeyEvent[] = [
  {
    activity: 'HpOneEnrollment-v02',
    action: 'ScreenDisplayed', // works as a button click validation, is not covered by validateSDEventsByPage.
    screenName: 'RedirectToHpId',
    screenPath: '/MagentoStorefront/',
    trackingAlias: 'RedirectToHpId',
  },
];
const checkoutKeyEvents: KeyEvent[] = [
  {
    action: 'ScreenDisplayed',
    activity: 'HpOneEnrollment-v02',
    screenName: 'BackFromHpId',
    screenPath: '/MagentoStorefront/',
  },
];

const checkoutKeyEventsOnRouteChange: KeyEvent[] = [
  {
    activity: 'HpOneEnrollment-v02',
    action: 'ControlButtonClicked',
    screenName: 'CheckoutOnePage',
    screenMode: 'AddShippingAddress',
    controlName: 'SaveAddress',
    screenPath: '/MagentoStorefront/',
    trackingAlias: 'SaveAddress',
  },
  {
    activity: 'HpOneEnrollment-v02',
    action: 'ControlButtonClicked',
    screenName: 'CheckoutOnePage',
    screenMode: 'AddPayment',
    controlName: 'SaveCard',
    screenPath: '/MagentoStorefront/',
    trackingAlias: 'SaveCard',
  },
  {
    activity: 'HpOneEnrollment-v02',
    action: 'ControlButtonClicked',
    screenName: 'CheckoutOnePage',
    controlName: 'CompleteYourPayment',
    screenPath: '/MagentoStorefront/',
    trackingAlias: 'CompleteYourPayment',
  },
];

const orderConfirmationKeyEvents: KeyEvent[] = [
  {
    activity: 'HpOneEnrollment-v02',
    screenPath: '/MagentoStorefront/',
    screenName: 'OrderConfirmation',
    screenMode: [
      'KeepInstantInk',
      'CancelInstantInk',
      'PrintOnly',
      'UnableToCancelInstantInk',
    ], //corner case -> there could be a lot of different outputs from order confirmation flow (eg: smooth transition), we don't have to track the value, only the property (just like the query that data team uses to report data loss)
    action: 'ScreenDisplayed',
    actionAuxParams: '', // not necessary to track the value, but the event should have this property
  },
];

export const keyEventsByPath: KeyEventsByPath = {
  '/pdp-config': pdpConfigKeyEvents,
  '/cart': cartKeyEvents,
  '/checkout': checkoutKeyEvents,
  '/order': orderConfirmationKeyEvents,
};

export const keyEventsByRouteChange: KeyEventsByPath = {
  '/cart': cartKeyEventsOnRouteChange,
  '/checkout': checkoutKeyEventsOnRouteChange,
};
